import React, { useContext } from 'react';
import styled from 'styled-components';
import { InputTextArea } from 'components';

import { TourItemContent } from '../types';
import TourEditContext from '../TourEditContext';

export interface TourNoteInputProps {
  item: TourItemContent;
}

const TourNoteInput: React.FC<TourNoteInputProps> = ({
  item: { id, note },
}) => {
  const { setTourNote } = useContext(TourEditContext);

  return (
    <StyledInput
      defaultValue={note}
      placeholder="Add date, time, or notes"
      onChange={e => setTourNote(e.target.value, id)}
    />
  );
};

export default TourNoteInput;

const StyledInput = styled(InputTextArea)`
  width: 86%;
`;
